import(/* webpackMode: "eager" */ "/workspace/apps/frontend/src/app/terms-and-conditions/page.tsx");
